import React from "react";
import { Reveal } from "@/components/Reveal";

const FAMILY_IMG =
  "https://images.unsplash.com/photo-1577896850715-ed0b7e3ece57?crop=entropy&cs=srgb&fm=jpg&w=1200&q=72&auto=format";

export default function FamilyDealer() {
  return (
    <section
      className="relative py-32 lg:py-40 px-6 lg:px-10 border-t border-[color:var(--border)] overflow-hidden"
      data-testid="family-dealer-section"
    >
      <div className="ambient-glow-blue" style={{ top: "20%", left: "-20%", opacity: 0.3 }} />
      <div className="mx-auto max-w-[1400px] relative">
        <div className="flex items-center gap-4 mb-8">
          <div className="h-[1px] w-16 bg-[color:var(--blue)]" />
          <div className="text-[11px] uppercase tracking-[0.4em] text-[color:var(--blue)]">
            Family Dealership
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-16 lg:gap-x-10 items-center">
          <Reveal className="col-span-12 lg:col-span-6" testId="family-dealer-copy">
            <h2 className="font-display font-semibold text-[clamp(2.5rem,7vw,6rem)] leading-[0.95] text-white">
              Local family.<br />
              <span className="font-editorial italic font-normal text-[color:var(--blue)]">
                Kinetico backing.
              </span>
            </h2>
            <div className="mt-8 text-[16px] lg:text-[18px] leading-[1.7] text-[color:var(--muted)] font-body max-w-lg">
              Family-owned. Locally staffed. Backed by the industry's most trusted water systems. Every install starts with a free in-home water test — no pressure, no upsell.
            </div>
          </Reveal>

          <Reveal delay={0.15} className="col-span-12 lg:col-span-6" y={80}>
            <div className="relative product-frame-alt overflow-hidden aspect-[4/5] lg:aspect-[3/4] bg-[color:var(--surface)]">
              <img
                src={FAMILY_IMG}
                alt="Family enjoying clean water at home"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--bg)]/70 via-transparent to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <div className="font-editorial italic text-white/95 text-2xl lg:text-3xl leading-tight">
                  &ldquo;We treat every install like it's going into our own kitchen.&rdquo;
                </div>
                <div className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[color:var(--blue)]">
                  — Vanguard Water Systems
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
